import { TimelineAvatarTypeT } from 'components/Timeline/types'
import type { AvatarWithIconT, HrAvatarT } from 'components/Timeline/types'
import type { TFunction } from 'react-i18next'
import { TIMELINE_STATUS } from 'redesign/components/organisms/timeline-item/constants'
import type {
  CreateAvatarIconProps,
  TimelineItemAttributes,
  TimelineItemValues,
  CreateTimelineItemProps,
} from '../types'
import { REVIEW_FRONTLINE_STATUSES, REVIEW_OFFICE_STATUSES } from './constants'
import type { CreateLastTimelineItemProps } from './types'

export const createAvatarIcon = (props: CreateAvatarIconProps) =>
  ({ ...props, type: TimelineAvatarTypeT.icon } as AvatarWithIconT)

export const createTimelineItemAttributesWithHrAvatar = (
  attributes: TimelineItemAttributes,
  t: TFunction,
): TimelineItemAttributes => ({
  ...attributes,
  avatarData: { userName: t('workTimeControl.timeline.HRManager'), type: TimelineAvatarTypeT.hr } as HrAvatarT,
})

export const createTimeLineItem = ({ attributes, content, reminder }: CreateTimelineItemProps) =>
  ({
    ...attributes,
    content,
    reminder,
  } as TimelineItemValues)

export const createClosedTimelineItemAttributes = ({ id, t }: CreateLastTimelineItemProps) => ({
  id,
  title: t('timeline.statusText.closed'),
  status: TIMELINE_STATUS.closed,
})

export const createWaitingUserTimelineItemAttributes = ({ id, t }: CreateLastTimelineItemProps) => ({
  id,
  title: t('timeline.statusText.waitingForUser'),
  status: TIMELINE_STATUS.current,
})

export const createWaitingTimelineItemAttributes = ({ id, t, isOffice, status }: CreateLastTimelineItemProps) => {
  const isOfficeTime = isOffice && REVIEW_OFFICE_STATUSES.includes(status ?? '')
  const isFrontlinerTime = !isOffice && REVIEW_FRONTLINE_STATUSES.includes(status ?? '')

  if (isFrontlinerTime || isOfficeTime) {
    return createWaitingUserTimelineItemAttributes({ id, t })
  }

  return {
    id,
    title: t(isOffice ? 'timeline.statusText.waitingForFrontliner' : 'timeline.statusText.waitingForManager'),
    status: TIMELINE_STATUS.current,
  }
}
